import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { APP_URLS } from '../../../Models/url';
import { UserService } from '../../../services/user.service';
import { MyProfileService } from '../../../services/my-profile.service';
import { TenantId } from '../../../Models/url';
import { CommonService } from '../../../services/common.service';
import { ModaldialogComponent } from '../../../pages/modaldialog/modaldialog.component';
import { ChangeDetectorRef } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-support-tickect-compose',
  templateUrl: './support-tickect-compose.component.html',
  styleUrls: ['./support-tickect-compose.component.css'],
})
export class SupportTickectComposeComponent implements OnInit {
  @ViewChild('f', { static: true }) f: NgForm;
  @ViewChild('takeInputfile', { static: false })
  InputVar: ElementRef;

  submitBtnDisabled = false;
  fileToUpload: any;
  fileName: any;
  fileSize: any;
  email: any;
  studentId: any;
  userRole = '';
  Ticket = {
    subject: '',
    comment: '',
  };

  p: number = 1;
  search: string;

  constructor(
    private profileSvc: MyProfileService,
    private toast: UserService,
    private cms: CommonService,
    private modalCom: ModaldialogComponent,
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
    this.studentId = JSON.parse(localStorage.getItem('userDetails'))._id;
    this.email = JSON.parse(localStorage.getItem('userDetails')).email;
    this.userRole = localStorage.getItem('role');
  }
  reset() {
    this.f.resetForm();
    this.InputVar.nativeElement.value = '';
  }
  handleFileInput(files) {
    this.fileSize = files.length ? files[0].size : 0;

    if (this.fileSize > 1024 * 5000) {
      this.toast.showError('File size should be smaller than 5mb');
      $('#file-input').val('');
      return;
    }

    var up_name = files.length ? files[0].name : 0;
    var fileExt = up_name.split('.').pop();
    var validExtensions = [
      'bmp',
      'doc',
      'docx',
      'gif',
      'jpeg',
      'jpg',
      'pdf',
      'rtf',
      'tif',
      'tiff',
      'txt',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
      'png',
    ];

    if (validExtensions.indexOf(fileExt) == -1) {
      var err_notify =
        'Only formats are allowed : ' + validExtensions.join(', ');
      this.toast.showError(err_notify);
      $('#file-input').val('');
      return;
    }

    this.submitBtnDisabled = true;
    const formData = new FormData();
    formData.append('images', files[0]);
    var url = APP_URLS.supportTicketUpload + '&frmSrc=support';
    this.profileSvc.postCallImg(url, formData).subscribe(
      (data: any) => {
        this.submitBtnDisabled = false;
        if (data.errorMessage) {
          this.toast.showError(data.errorMessage);
        } else if (data.message) {
          this.fileName = '';
          this.toast.showError(data.message);
        } else {
          if (data.length) this.fileName = data[0].name;
          this.toast.showSuccess(
            'Your chosen file is attached successfully. Now click on submit button'
          );
        }
      },
      (err) => {
        this.fileName = '';
        if (err.errorMessage) {
          this.toast.showError(err.errorMessage);
        } else {
          this.toast.showError('Error');
        }
      }
    );
  }
  submit() {
    // this.cms.loaderSet(true);
    var payload = {};
    let url = '';
    if (this.userRole == 'employer') {
      payload = {
        subject: this.Ticket.subject,
        message: this.Ticket.comment,
        attachments: [
          {
            name: this.fileName,
          },
        ],
      };
      url = APP_URLS.v1.createSupportTicket;
      this.profileSvc.postCall(url, payload).subscribe(
        (res: any) => {
          if (res.respCode == 200 || res.respCode == 201) {
            // this.cms.loaderSet(false);
            this.toast.showSuccess(res.respMessage);
            this.Ticket.subject = '';
            this.Ticket.comment = '';
            this.profileSvc.setSupportCompose('data');
          } else {
            // this.cms.loaderSet(false);
            this.toast.showError(res.respMessage);
          }
          this.modalCom.close();
          this.reset();
        },
        (err) => {
          // this.cms.loaderSet(false);
          this.toast.showError(err.errorMessage);
        }
      );
    } else {
      payload = {
        inbox_type: '',
        message: this.Ticket.comment,
        subject: this.Ticket.subject,
        attachments: [
          {
            name: this.fileName,
            path: '',
          },
        ],
        to: ['crm@abacademy.co.uk'],
      };
      url = APP_URLS.v1.createSupportTicket;
      this.profileSvc.postCall(url, payload).subscribe(
        (res: any) => {
          if (res.respCode == 200 || res.respCode == 201) {
            // this.cms.loaderSet(false);
            this.toast.showSuccess(res.respMessage);
            this.Ticket.subject = '';
            this.Ticket.comment = '';
            this.profileSvc.setSupportCompose('data');
          } else {
            // this.cms.loaderSet(false);
            this.toast.showError(res.respMessage);
          }
          this.modalCom.close();
          this.reset();
        },
        (err) => {
          // this.cms.loaderSet(false);
          this.toast.showError(err.errorMessage);
        }
      );
    }
  }
}
